<div class="wrapper" *ngIf="record">
  <div class="request-actions" *ngIf="showPrintButton">
    <div
      class="icon_image"
      (click)="exportAsPDF()"
      pTooltip="Imprimir en PDF"
      tooltipPosition="left"
      [tooltipOptions]="{ appendTo: 'body' }"
    >
      <i
        class="pi pi-file-pdf"
        style="font-size: 2rem"
        *ngIf="!exportingFlag"
      ></i>
      <i
        class="pi pi-spin pi-spinner"
        style="font-size: 2rem"
        *ngIf="exportingFlag"
      ></i>
    </div>
    <div
      class="icon_image icon_image--copy"
      (click)="openCopyDialog()"
      [pTooltip]="'REQUEST_COPY.TOOLTIP' | translate"
      tooltipPosition="left"
      [tooltipOptions]="{ appendTo: 'body' }"
    >
      <i class="pi pi-copy" style="font-size: 2rem"></i>
    </div>
  </div>

  <div class="paper" id="request">
    <afoone-patient-request-header
      [request]="record"
    ></afoone-patient-request-header>
    <afoone-patient-data [patient]="patient"></afoone-patient-data>
    <div class="header">
      <ng-container *ngFor="let item of headerItems">
        <div
          class="header-block"
          [ngStyle]="{ 'grid-column': 'span ' + item.span }"
        >
          <span class="title">{{
            "REQUEST_DATA." + item.key | uppercase | translate
          }}</span>
          <span>{{
            item.pipe ? item.pipe(record[item.key]) : record[item.key]
          }}</span>
        </div>
      </ng-container>
    </div>

    <!-- Panel Acumulados: solo si LabType es LABC [[6]][[8]]; no mostrarlo en pantalla 1.4 desde acumulados [[19]] -->
    <p-panel
      *ngIf="!hideAcumuladosPanel && record.tests?.length && isLabTypeLABC"
      [header]="'ACUMULADOS.TITLE' | translate"
      [toggleable]="true"
      [collapsed]="true"
      iconPos="start"
      expandIcon="pi pi-chevron-down"
      collapseIcon="pi pi-chevron-right"
      styleClass="acumulados-panel"
    >
      <div class="acumulados-criteria">
        <div class="acumulados-date-group">
          <label class="acumulados-label">{{ 'ACUMULADOS.ANTERIORES_A' | translate }}</label>
          <div class="acumulados-date-options">
            <div class="acumulados-date-row">
              <p-radioButton
                name="referenceDateMode"
                [value]="'concrete'"
                [(ngModel)]="referenceDateMode"
                [inputId]="'ref-concrete'"
              ></p-radioButton>
              <label [for]="'ref-concrete'">{{ 'ACUMULADOS.FECHA_CONCRETA' | translate }}</label>
              <p-calendar
                *ngIf="referenceDateMode === 'concrete'"
                [(ngModel)]="referenceDateConcrete"
                dateFormat="dd/mm/yy"
                inputId="acumulados-date"
                [readonlyInput]="true"
                [firstDayOfWeek]="1"
                [minDate]="minAcumuladosDate"
                [maxDate]="maxAcumuladosDate"
                [showClear]="false"
                [showButtonBar]="true"
                (onSelect)="referenceDateMode = 'concrete'"
                (ngModelChange)="onAcumuladosReferenceDateChange($event)"
                appendTo="body"
                panelStyleClass="acumulados-datepicker-panel"
              ></p-calendar>
            </div>
            <div class="acumulados-date-row">
              <p-radioButton
                name="referenceDateMode"
                [value]="'request'"
                [(ngModel)]="referenceDateMode"
                [inputId]="'ref-request'"
              ></p-radioButton>
              <label [for]="'ref-request'">{{ 'ACUMULADOS.FECHA_PETICION' | translate }}</label>
            </div>
          </div>
        </div>
        <div class="acumulados-buttons">
          <p-button
            [label]="'ACUMULADOS.BUSCAR' | translate"
            (onClick)="buscarAcumulados()"
            [loading]="acumuladosLoading"
            icon="pi pi-search"
          ></p-button>
          <p-button
            [label]="'ACUMULADOS.GRAFICAS_EVOLUCION' | translate"
            (onClick)="graficasEvolucion()"
            [loading]="acumuladosLoading"
            [disabled]="!canShowGraficasEvolucion"
            icon="pi pi-chart-line"
            styleClass="p-button-outlined"
          ></p-button>
          <div class="acumulados-hints">
            <span class="acumulados-hint">{{ 'ACUMULADOS.TESTS_SELECTED_COUNT' | translate: { count: selectedTestsForAcumulados.length } }}</span>
            <span class="acumulados-hint acumulados-hint--graficas">{{ 'ACUMULADOS.GRAFICAS_EVOLUCION_RANGO' | translate }}</span>
          </div>
        </div>
      </div>
      <p class="acumulados-hint-list">{{ 'ACUMULADOS.SELECCION_EN_LISTA' | translate }}</p>
      <div *ngIf="acumuladosError" class="acumulados-error">
        {{ acumuladosError }}
      </div>
      <p
        *ngIf="acumuladosResult?.length === 0 && !acumuladosLoading"
        class="acumulados-result"
      >
        {{ 'ACUMULADOS.SIN_RESULTADOS' | translate }}
      </p>
    </p-panel>

    <afoone-epidemiology-search-panel
      *ngIf="canShowEpidemiologyPanel && patient"
      [patientId]="patient.historia"
      [labNr]="record.labNr"
      [centerId]="defaultSisifoCenterId"
      [detailLaboratorio]="microbiologyLaboratoryCode"
    ></afoone-epidemiology-search-panel>

    <afoone-request-tests-list
      *ngIf="record.tests?.length"
      [tests]="record.tests"
      [showAcumuladosSelection]="!hideAcumuladosPanel && isLabTypeLABC"
      [selectedForAcumulados]="selectedTestsForAcumulados"
      (selectedForAcumuladosChange)="selectedTestsForAcumulados = $event"
    ></afoone-request-tests-list>

    <div class="materials" *ngIf="record.materiales?.length">
      <afoone-request-materials
        [materials]="record.materiales"
      ></afoone-request-materials>
    </div>

    <div class="signatures">
      <afoone-signatures [signatures]="record.signatures"></afoone-signatures>
    </div>
  </div>

  <p-dialog
    [(visible)]="copyDialogVisible"
    [header]="'REQUEST_COPY.TITLE' | translate"
    [modal]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="true"
    [style]="{ width: 'min(90vw, 960px)' }"
    styleClass="request-copy-dialog"
    [contentStyle]="{ overflow: 'hidden' }"
  >
    <textarea
      readonly
      class="request-copy-textarea"
      rows="22"
      [value]="copyDialogText"
      aria-readonly="true"
    ></textarea>
    <ng-template pTemplate="footer">
      <p-button
        [label]="'REQUEST_COPY.CLOSE' | translate"
        icon="pi pi-times"
        (onClick)="closeCopyDialog()"
        styleClass="p-button-text"
      ></p-button>
      <p-button
        [label]="'REQUEST_COPY.COPY_CLIPBOARD' | translate"
        icon="pi pi-copy"
        (onClick)="copyPlainTextToClipboard()"
      ></p-button>
    </ng-template>
  </p-dialog>
</div>
